export default function Item({items}) {
	if (typeof items === 'undefined') return <></>;

	return items.map((item: string, key: number) => {
		return (
			<li key={key} className="usage__list-item">
				{item}
			</li>
		);
	});
}